var PassEqual = (function() {
	var __private = {
		main  : null,
		copy  : null,
		button: null,
		invalidClass: "invalid",
		message: "Passwords do not match",

		set(main, copy) {
			if(main && main instanceof HTMLInputElement) this.main = main;
			if(copy && copy instanceof HTMLInputElement) this.copy = copy;

			if(this.main !== null) {
				let form = this.main.form;

				if(document.querySelector("input[type='submit']"))
					this.button = form.querySelector("input[type='submit']");
			}
		},

		listener() {
			if(this.copy instanceof HTMLInputElement && this.main instanceof HTMLInputElement) {
				this.main.addEventListener("input", function() {
					if(__private.copy.value && __private.copy.value != "") __private.validation();
				});

				this.copy.addEventListener("input", function() {
					__private.validation();
				});
			}
		},

		validation() {
			if(__private.comparison()) {
				__private.main.classList.remove(__private.invalidClass);
				__private.copy.classList.remove(__private.invalidClass);
				__private.button.disabled = false;
				__private.error(false);
			} else {
				__private.copy.classList.add(__private.invalidClass);
				__private.main.classList.add(__private.invalidClass);
				__private.button.disabled = true;
				__private.error(true);
			}
		},

		comparison() {
			if(__private.main instanceof HTMLInputElement && __private.copy instanceof HTMLInputElement) {
				if(__private.main.value === __private.copy.value) return true;
				else return false;
			} else return false;
		},

		error(flag) {
			var errorElem;
			var errorID = "passError";
			var errorClass = "has-error_block";

			if(document.getElementById(errorID)) errorElem = document.getElementById(errorID);
			else {
				errorElem = document.createElement("div");
				errorElem.id = errorID;
				errorElem.classList.add(errorClass);

				__private.button.parentElement.insertBefore(errorElem, __private.button);
			}

			errorElem.textContent = __private.message;

			if(flag) errorElem.style.display = "block";
			else     errorElem.style.display = "none";
		}
	};

	return {
		init(main, copy) {
			__private.set(main, copy);
			__private.listener();
		}
	};
})();

(function() {
	document.addEventListener("DOMContentLoaded", function() {

		// Register
		if(document.getElementById("password") && document.getElementById("confirmPassword")) {
			PassEqual.init(
				document.getElementById("password"), 
				document.getElementById("confirmPassword")
			);
		}

		// Change password
		if(document.getElementById("newPassword") && document.getElementById("confirmNewPassword")) {
			PassEqual.init(
				document.getElementById("newPassword"), 
				document.getElementById("confirmNewPassword")
			);
		}

		// Forgot password
		if(document.getElementById("password") && document.getElementById("password-confirm")) {
			PassEqual.init(
				document.getElementById("password"), 
				document.getElementById("password-confirm")
			);
		}
		
	});
})();